import { CUSTOMER_STATUS_LEVELS, RestaurantCustomer } from "@lemmonhq/types";

export const getCustomerId = (customer: RestaurantCustomer) => customer.customer_id ?? customer.id;

export const getBirthdayLabel = (customer: RestaurantCustomer) => {
  if (!customer.birth_day_month) return "";
  const [month, day] = customer.birth_day_month.split("-");
  const date = new Date(customer.birth_year ?? 2000, Number(month) - 1, Number(day));
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    ...(customer.birth_year ? { year: "numeric" } : {}),
  });
};

export const normalizeBirthDayMonth = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const match = trimmed.match(/^(\d{1,2})-(\d{1,2})$/);
  if (!match) return null;

  const month = Number(match[1]);
  const day = Number(match[2]);
  const date = new Date(2000, month - 1, day);
  if (date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }

  return `${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

export const normalizeBirthYear = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const year = Number(trimmed);
  if (!Number.isInteger(year) || year < 1900 || year > 2100) {
    return null;
  }

  return year;
};

export const customerStatusLabel = (status: string | null | undefined, t: (key: string) => string) => {
  switch (status) {
    case CUSTOMER_STATUS_LEVELS.VIP:
      return t("reservations.customers.vip");
    case CUSTOMER_STATUS_LEVELS.NEW:
      return t("reservations.customers.new");
    case CUSTOMER_STATUS_LEVELS.REGULAR:
      return t("reservations.customers.regular");
    case CUSTOMER_STATUS_LEVELS.INACTIVE:
      return t("reservations.customers.inactive");
    default:
      return String(status || "");
  }
};

export const formatOrderId = (id: unknown) =>
  String(id ?? "")
    .slice(-6)
    .toUpperCase();

export const reservationStatusLabel = (status: string | null | undefined, t: (key: string) => string) => {
  const normalized = String(status || "").replace(/-/g, "_");
  if (!normalized) return "";
  const key = `reservations.customers.status_${normalized}`;
  const translated = t(key);
  return translated === key ? String(status) : translated;
};

export const orderStatusLabel = (status: string | null | undefined, t: (key: string) => string) => {
  const normalized = String(status || "").replace(/-/g, "_");
  if (!normalized) return "";
  const key = `reservations.customers.order_status_${normalized}`;
  const translated = t(key);
  return translated === key ? String(status) : translated;
};
